import { Building2, Check, HardHat, Laptop, Scale } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { salvaTipo, useTipo } from "@/lib/segmento";

const COPY = {
  it: {
    title: "Seleziona chi sei, carico la tua memoria già pronta:",
    sub: "L'esempio della demo qui sotto cambia in base al tuo lavoro.",
    tipi: {
      artigiano: "Artigiano / Installatore",
      freelance: "Freelance / Consulente",
      avvocato: "Avvocato / Commercialista",
      pmi: "PMI / Azienda",
    },
  },
  en: {
    title: "Pick who you are, I'll load your ready-made memory:",
    sub: "The example in the demo below changes to match your work.",
    tipi: {
      artigiano: "Tradesperson / Installer",
      freelance: "Freelancer / Consultant",
      avvocato: "Lawyer / Accountant",
      pmi: "SME / Company",
    },
  },
};

const ICONE = {
  artigiano: HardHat,
  freelance: Laptop,
  avvocato: Scale,
  pmi: Building2,
};

export const SegmentPicker = () => {
  const { lang } = useI18n();
  const c = COPY[lang] || COPY.en;
  const tipo = useTipo();

  return (
    <section
      className="border-t border-slate-200 bg-white px-6 pt-8 pb-3 text-center lg:px-16 lg:pt-14 lg:pb-4"
      data-testid="segment-picker"
    >
      <h2 className="mx-auto max-w-2xl text-xl font-extrabold tracking-tight sm:text-2xl lg:text-3xl">
        {c.title}
      </h2>
      <p className="mx-auto mt-2 hidden max-w-xl text-sm text-slate-600 sm:block md:text-base">{c.sub}</p>
      <div className="mt-4 grid grid-cols-2 gap-2 sm:mt-8 sm:flex sm:flex-wrap sm:justify-center sm:gap-3">
        {Object.entries(c.tipi).map(([chiave, etichetta]) => {
          const Icona = ICONE[chiave];
          const attivo = tipo === chiave;
          return (
            <button
              key={chiave}
              type="button"
              data-testid={`segment-${chiave}`}
              onClick={() => salvaTipo(chiave)}
              className={`inline-flex items-center justify-center gap-1.5 rounded-full border px-3 py-2.5 text-xs font-semibold transition-all duration-200 sm:gap-2 sm:px-5 sm:py-3 sm:text-sm ${
                attivo
                  ? "border-slate-900 bg-slate-900 text-white shadow-[0_10px_30px_-12px_rgba(2,6,23,0.6)]"
                  : "border-slate-300 bg-white text-slate-700 hover:-translate-y-0.5 hover:border-slate-900 hover:text-slate-900"
              }`}
            >
              {attivo ? <Check className="h-3.5 w-3.5 shrink-0 sm:h-4 sm:w-4" /> : <Icona className="h-3.5 w-3.5 shrink-0 sm:h-4 sm:w-4" />}
              {etichetta}
            </button>
          );
        })}
      </div>
    </section>
  );
};
